import script from "./eidtPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./eidtPhone.vue?vue&type=script&setup=true&lang=js"

import "./eidtPhone.vue?vue&type=style&index=0&id=27e1de56&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/mgtpr6vc/mgt-elearning/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e1de56"]])

export default __exports__